import NestedModifiersType1 from "./nestedModifiersType1";

export default NestedModifiersType1;
